module.exports = __webpack_public_path__ + "img/1xbet.faee7674.png";